import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["richTextEditor", "htmlEditor", "richTextBtn", "htmlBtn"]

  connect() {
    // Start with rich text editor visible
    this.showRichText()
  }

  showRichText() {
    this.richTextEditorTarget.classList.remove("hidden")
    this.htmlEditorTarget.classList.add("hidden")
    
    this.richTextBtnTarget.classList.remove("bg-gray-200", "text-gray-700")
    this.richTextBtnTarget.classList.add("bg-blue-500", "text-white")
    
    this.htmlBtnTarget.classList.remove("bg-blue-500", "text-white")
    this.htmlBtnTarget.classList.add("bg-gray-200", "text-gray-700")
  }

  showHtml() {
    this.richTextEditorTarget.classList.add("hidden")
    this.htmlEditorTarget.classList.remove("hidden")
    
    this.htmlBtnTarget.classList.remove("bg-gray-200", "text-gray-700")
    this.htmlBtnTarget.classList.add("bg-blue-500", "text-white")
    
    this.richTextBtnTarget.classList.remove("bg-blue-500", "text-white")
    this.richTextBtnTarget.classList.add("bg-gray-200", "text-gray-700")
  }
}
